import { useMutation } from '@tanstack/react-query';
import { gerarRelatorioPdfApi } from '../api/GerarRelatorioPDFApi';
import type { GerarRelatorioPayload, GerarRelatorioPDFResponse } from '../types';

export function useGerarRelatorioPDF() {
  return useMutation<GerarRelatorioPDFResponse, Error, GerarRelatorioPayload>({
    mutationFn: gerarRelatorioPdfApi,
  });
}
